import { AuthenticationResult } from '../../domain/users/authenticate-user';
import { Login } from '../../domain/users/login-user';
import ssoClient from '../http/ssoClient';
import { LocalStorage_keys } from '../../main/constants';
import { localStorageService } from './localStorageService';
import { getActionService } from './getActionService';

const authenticate = async (credentials: Login): Promise<AuthenticationResult> => {
    const user = await ssoClient.login(credentials);

    if (user.token) {
        localStorageService.create(LocalStorage_keys.JWT_KEY, user.token);
        localStorageService.create(LocalStorage_keys.USER_KEY, user.employee);
    }

    return user;
};

const logout = () => {
    localStorageService.clear(LocalStorage_keys.USER_KEY);
    localStorageService.clear(LocalStorage_keys.JWT_KEY);
};

const authenticationService = {
    authenticate,
    logout,
};

export default authenticationService;
